module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0122.jpg?v=df575569";